module.exports = __webpack_public_path__ + "static/media/fudan.9193cedd.png";